var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vx-card" },
    [
      _c("div", { staticClass: "vx-card__collapsible-content" }, [
        _c("div", { staticClass: "vx-card__body row" }, [
          _c("div", { staticClass: "col-md-4 col-12" }, [
            _c("h4", { staticClass: "text-primary" }, [_vm._v("Opciones")]),
            _vm.isLoadOptions
              ? _c(
                  "div",
                  [
                    _c("b-spinner", {
                      key: "primary",
                      staticClass: "mr-1",
                      attrs: { variant: "primary" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isLoadOptions
              ? _c("div", { staticClass: "input-group mb-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "Buscar grupo de opciones",
                      "aria-label": "Buscar grupo de opciones",
                      "aria-describedby": "input-search"
                    },
                    domProps: { value: _vm.search },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value
                      }
                    }
                  }),
                  _vm.checkIfIsSuperAdmin
                    ? _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: "Agregar nuevo grupo de opciones",
                                expression: "'Agregar nuevo grupo de opciones'"
                              }
                            ],
                            staticClass: "btn btn-outline-secondary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.addOptionGroup()
                              }
                            }
                          },
                          [_c("feather-icon", { attrs: { icon: "PlusIcon" } })],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _c(
              "ul",
              {
                staticClass: "list-group mt-5",
                staticStyle: { "max-height": "80vh", overflow: "scroll" }
              },
              _vm._l(_vm.filteredOptions, function(option, $indexParam) {
                return _c(
                  "li",
                  {
                    key: "option-" + $indexParam,
                    staticClass:
                      "list-group-item d-flex justify-content-between align-content-center",
                    attrs: { id: "option-" + $indexParam }
                  },
                  [
                    _c("div", { staticClass: "d-flex flex-row" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12 col-12 mt-2" }, [
                          _c("div", { staticClass: "about pr-3" }, [
                            _vm.checkIfIsSuperAdmin
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Migrar Opción",
                                        expression: "'Migrar Opción'"
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.migrateOptionGroup(option)
                                      }
                                    }
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-1 cursor-pointer",
                                      attrs: { icon: "SendIcon" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.checkIfIsSuperAdmin
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Editar grupo de opciones",
                                        expression: "'Editar grupo de opciones'"
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.editOptionGroup(option)
                                      }
                                    }
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-1 cursor-pointer",
                                      attrs: { icon: "SettingsIcon" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.checkIfIsSuperAdmin
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Ocultar grupo de opciones",
                                        expression:
                                          "'Ocultar grupo de opciones'"
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteOptionGroup(option)
                                      }
                                    }
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-1 cursor-pointer",
                                      attrs: { icon: "TrashIcon", color: "red" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "label",
                              {
                                staticClass: "ml-4 cursor-pointer",
                                on: {
                                  click: function($event) {
                                    return _vm.selectOptionPatent(option)
                                  }
                                }
                              },
                              [
                                _vm._v(" " + _vm._s(option.descripcion) + " "),
                                option.valor
                                  ? _c(
                                      "small",
                                      { staticClass: "d-block text-muted" },
                                      [_vm._v(_vm._s(option.valor))]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _vm.optionSelected
            ? _c("div", { staticClass: "col-8" }, [
                _c(
                  "div",
                  [
                    _vm.optionSelected.extra.type === "tree"
                      ? _c("options-configurations-tree", {
                          key: "config-panel-" + _vm.optionSelected.opcionId,
                          attrs: {
                            title: _vm.optionSelected.descripcion,
                            "group-id": _vm.optionSelected.valor,
                            "children-levels-limit":
                              _vm.optionSelected.extra.maxTreeNodes || 2,
                            "value-type-config":
                              _vm.optionSelected.extra.valueTypes || "text",
                            "extra-type-render":
                              _vm.optionSelected.extra.extraRenderType ||
                              "json",
                            extras: _vm.optionSelected.extra || {}
                          }
                        })
                      : _c("options-configurations-list", {
                          key: "config-panel-" + _vm.optionSelected.opcionId,
                          attrs: {
                            title: _vm.optionSelected.descripcion,
                            "group-id": _vm.optionSelected.valor,
                            "value-type-config":
                              _vm.optionSelected.extra.valueTypes || "text",
                            "extra-type-render":
                              _vm.optionSelected.extra.extraRenderType ||
                              "json",
                            extras: _vm.optionSelected.extra || {}
                          }
                        })
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      ]),
      _c(
        "b-modal",
        {
          ref: "option-config",
          attrs: {
            id: "option-config",
            title: "Configurar Grupo de opciones",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            size: "xl"
          }
        },
        [
          _vm.optionConfigure
            ? _c("div", { staticClass: "row mb-5" }, [
                _c("div", { staticClass: "col-md-8 col-12 mt-3" }, [
                  _c("label", [_vm._v("Nombre de la opción")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.optionConfigure.descripcion,
                        expression: "optionConfigure.descripcion"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { maxlength: "250" },
                    domProps: { value: _vm.optionConfigure.descripcion },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.optionConfigure,
                          "descripcion",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _vm._v("Nombre para identificar la opción")
                  ])
                ]),
                _c("div", { staticClass: "col-md-8 col-12 mt-3" }, [
                  _c("label", [_vm._v("Descripcion de la opción")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.optionConfigure.extra.descripcion,
                        expression: "optionConfigure.extra.descripcion"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { maxlength: "250" },
                    domProps: { value: _vm.optionConfigure.extra.descripcion },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.optionConfigure.extra,
                          "descripcion",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _vm._v("Nombre para identificar la opción")
                  ])
                ]),
                _vm.checkIfIsSuperAdmin
                  ? _c("div", { staticClass: "col-md-4 col-12 mt-3" }, [
                      _c("label", [_vm._v("Nivel de la opción (grupo)")]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.optionConfigure.nivel,
                              expression: "optionConfigure.nivel"
                            }
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.optionConfigure,
                                "nivel",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "0", selected: "" } },
                            [_vm._v(" Global ")]
                          ),
                          _c("option", { attrs: { value: "10" } }, [
                            _vm._v(" Empresa ")
                          ])
                        ]
                      ),
                      _c("small", { staticClass: "form-text text-muted" }, [
                        _vm._v(
                          " Nivel de visualización del tipo de opciones (grupo) "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm.checkIfIsSuperAdmin
                  ? _c("div", { staticClass: "col-md-4 col-12 mt-3" }, [
                      _c("label", [_vm._v("Nivel de la opción (opciones)")]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.optionConfigure.extra.nivel,
                              expression: "optionConfigure.extra.nivel"
                            }
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.optionConfigure.extra,
                                "nivel",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "0", selected: "" } },
                            [_vm._v(" Global ")]
                          ),
                          _c("option", { attrs: { value: "10" } }, [
                            _vm._v(" Empresa ")
                          ])
                        ]
                      ),
                      _c("small", { staticClass: "form-text text-muted" }, [
                        _vm._v(" Nivel de visualización de las opciones ")
                      ])
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "col-md-6 col-12 mt-3" }, [
                  _c("label", [_vm._v("Grupo de opción a configurar")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.optionConfigure.valor,
                        expression: "optionConfigure.valor"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { maxlength: "250" },
                    domProps: { value: _vm.optionConfigure.valor },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.optionConfigure,
                          "valor",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _vm._v(
                      " Identificador de grupo sobre el cual se agruparan las opciones "
                    )
                  ])
                ]),
                _c("div", { staticClass: "col-md-6 mt-3" }, [
                  _c("label", [_vm._v("Tipo de valor de las opciones")]),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.optionConfigure.extra.valueTypes,
                          expression: "optionConfigure.extra.valueTypes"
                        }
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.optionConfigure.extra,
                            "valueTypes",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "text", selected: "" } }, [
                        _vm._v(" Texto ")
                      ]),
                      _c("option", { attrs: { value: "number" } }, [
                        _vm._v("Numero")
                      ]),
                      _c("option", { attrs: { value: "text-large" } }, [
                        _vm._v("Texto Largo")
                      ]),
                      _c("option", { attrs: { value: "switch" } }, [
                        _vm._v("Y o N")
                      ]),
                      _c("option", { attrs: { value: "option" } }, [
                        _vm._v("Opciones")
                      ]),
                      _c("option", { attrs: { value: "s3-html" } }, [
                        _vm._v("Html en S3")
                      ]),
                      _c("option", { attrs: { value: "s3-text" } }, [
                        _vm._v("Texto en S3")
                      ]),
                      _c("option", { attrs: { value: "s3-xsl" } }, [
                        _vm._v("XSL en S3")
                      ]),
                      _c("option", { attrs: { value: "s3-file" } }, [
                        _vm._v("Archivo en S3")
                      ]),
                      _c("option", { attrs: { value: "s3-image" } }, [
                        _vm._v("Imagen en S3")
                      ]),
                      _c("option", { attrs: { value: "set" } }, [
                        _vm._v("Set de configuraciones")
                      ])
                    ]
                  ),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _vm._v(
                      " De que tipo son los valores que se configuraran en las opciones "
                    )
                  ])
                ]),
                _c("div", { staticClass: "col-md-6 mt-3" }, [
                  _c("label", [_vm._v("Como se muestra la información extra")]),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.optionConfigure.extra.extraRenderType,
                          expression: "optionConfigure.extra.extraRenderType"
                        }
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.optionConfigure.extra,
                            "extraRenderType",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "json", selected: "" } }, [
                        _vm._v(" JSON ")
                      ])
                    ]
                  ),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _vm._v(
                      " Tipo de visualización del listado de opciones para su configuración "
                    )
                  ])
                ]),
                _c("div", { staticClass: "col-md-6 mt-3" }, [
                  _c("label", [_vm._v("Tipo de configuración")]),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.optionConfigure.extra.type,
                          expression: "optionConfigure.extra.type"
                        }
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.optionConfigure.extra,
                            "type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "list", selected: "" } }, [
                        _vm._v(" Lista ")
                      ]),
                      _c("option", { attrs: { value: "tree" } }, [
                        _vm._v(" Arbol ")
                      ])
                    ]
                  ),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _vm._v(
                      " Tipo de visualización del listado de opciones para su configuración "
                    )
                  ])
                ]),
                _vm.optionConfigure.extra.type === "tree"
                  ? _c("div", { staticClass: "col-md-6 mt-3" }, [
                      _c("label", [_vm._v("Máximo de nodos")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.optionConfigure.extra.maxTreeNodes,
                            expression: "optionConfigure.extra.maxTreeNodes"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { max: "10", type: "number" },
                        domProps: {
                          value: _vm.optionConfigure.extra.maxTreeNodes
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.optionConfigure.extra,
                              "maxTreeNodes",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _c("small", { staticClass: "form-text text-muted" }, [
                        _vm._v(" Hasta cuantos nodos puede tener un arbol ")
                      ])
                    ])
                  : _vm._e(),
                _vm.checkIfIsSuperAdmin
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("vue-json-editor", {
                          attrs: {
                            mode: "code",
                            modes: ["code"],
                            "show-btns": false,
                            exapndedOnStart: true
                          },
                          on: {
                            "json-change": _vm.onExtraJsonChange,
                            "has-error": _vm.onExtraJsonError
                          },
                          model: {
                            value: _vm.optionConfigure.extra,
                            callback: function($$v) {
                              _vm.$set(_vm.optionConfigure, "extra", $$v)
                            },
                            expression: "optionConfigure.extra"
                          }
                        }),
                        !_vm.jsonExtraValid
                          ? _c("div", { staticClass: "text-danger mt-1" }, [
                              _vm._v(
                                " El JSON del campo extra no es válido. Corrija la sintaxis para poder guardar. "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.checkIfIsSuperAdmin
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("h3", [
                          _vm._v(
                            "Template base para extras de una nueva opción"
                          )
                        ]),
                        _c("vue-json-editor", {
                          attrs: {
                            mode: "code",
                            modes: ["code"],
                            "show-btns": false,
                            exapndedOnStart: true
                          },
                          on: {
                            "json-change": _vm.onExtrasJsonChange,
                            "has-error": _vm.onExtrasJsonError
                          },
                          model: {
                            value: _vm.optionConfigure.extra.extras,
                            callback: function($$v) {
                              _vm.$set(_vm.optionConfigure.extra, "extras", $$v)
                            },
                            expression: "optionConfigure.extra.extras"
                          }
                        }),
                        !_vm.jsonExtrasValid
                          ? _c("div", { staticClass: "text-danger mt-1" }, [
                              _vm._v(
                                " El JSON del campo extras no es válido. Corrija la sintaxis para poder guardar. "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "col-md-12 mt-3" }, [
                  _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      !_vm.isSavingOption
                        ? _c(
                            "vs-button",
                            {
                              staticClass: "action",
                              attrs: {
                                color: "primary",
                                type: "border",
                                icon: "save",
                                disabled: !_vm.isJsonValid
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveOption()
                                }
                              }
                            },
                            [_vm._v(" Guardar ")]
                          )
                        : _c("b-spinner", {
                            key: "primary",
                            staticClass: "mr-1",
                            attrs: { variant: "primary" }
                          })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]
      ),
      _c("option-migration-modal", { ref: "option-migration-modal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }